import { Button, ButtonCircle } from "@chef/components";
import { CurrencyWrapper as Currency } from "@chef/smart-components";
import { Check } from "@chef/icons/small";
import { intl } from "./GiftCardAmountPickers.Intl";

interface AmountPickerProps {
  onSelectClicked: () => void;
  onDeselectClicked: () => void;
  children?: React.ReactNode;
  description: string;
  amount: string;
  isActive: boolean;
}

export const PresetGiftCardAmountPicker = ({
  onDeselectClicked,
  onSelectClicked,
  description,
  amount,
  isActive,
}: AmountPickerProps) => {
  return (
    <div className="flex justify-between mx-4 my-5 lg:mx-6 xl:mx-8">
      <div className="mb-2">
        <Currency emphasized>{+amount}</Currency>

        <p className="mt-2 text-sm text-grey-1 md:text-base">{description}</p>
      </div>

      <AddRemoveButton
        onDeselectClicked={onDeselectClicked}
        onSelectClicked={onSelectClicked}
        isAdded={isActive}
        id={"gift-card-amount-" + amount}
      />
    </div>
  );
};

interface AddRemoveButtonProps {
  id?: string;
  isAdded: boolean;
  onDeselectClicked: () => void;
  onSelectClicked: () => void;
}

const AddRemoveButton = ({
  isAdded,
  onDeselectClicked,
  onSelectClicked,
  id,
}: AddRemoveButtonProps) => {
  if (isAdded) {
    return (
      <ButtonCircle primary onClick={onDeselectClicked} Icon={Check} id={id} />
    );
  }

  return (
    <Button onClick={onSelectClicked} outlined type="button" id={id}>
      {intl.CHOOSE}
    </Button>
  );
};

interface CustomAmountPickerProps {
  Input: React.ReactNode;
  onDeselectClicked: () => void;
  onSelectClicked: () => void;
  description: string;
  isActive: boolean;
}

export const CustomAmountGiftCardPicker = ({
  Input,
  onDeselectClicked,
  onSelectClicked,
  description,
  isActive,
}: CustomAmountPickerProps) => {
  return (
    <div className="flex flex-col mx-4 my-5 lg:mx-6 xl:mx-8">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <strong>{intl.ENTER_YOUR_OWN_AMOUNT} </strong>
          <p className="mt-2 text-sm md:text-base text-grey-1">{description}</p>
        </div>

        <AddRemoveButton
          onDeselectClicked={onDeselectClicked}
          onSelectClicked={onSelectClicked}
          isAdded={isActive}
        />
      </div>

      {Input}
    </div>
  );
};
